import store from "../../store/store"
import { ClassifiersHub } from "../hubs/classifiers"

export const classifiersHub = new ClassifiersHub(store)
